import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  Select,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  FormControl,
  InputAdornment,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
import { UPDATE_ITEM } from "../../Schema/ListItem";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function UpdateListItem({
  open,
  editData,
  setRefetch,
  handleClose,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [updateItem] = useMutation(UPDATE_ITEM, {
    onCompleted: ({ updateItem }) => {
      setLoading(false);
      if (updateItem?.status === true) {
        setAlert(true, "success", updateItem?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateItem?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const Validate = Yup.object().shape({
    itemDescription: Yup.string(),
    itemName: Yup.string().required("require!"),
    incomeType: Yup.string().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      itemName: "",
      incomeType: "",
      itemDescription: "",
    },

    validationSchema: Validate,
    onSubmit: async (values) => {
      setLoading(true);

      updateItem({
        variables: {
          id: editData?._id,
          input: {
            ...values,
          }
        },
      });
    },
  });


  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;


  useEffect(() => {
    if (editData) {
      setFieldValue("itemName", editData?.itemName);
      setFieldValue("incomeType", editData?.incomeType);
      setFieldValue("itemDescription", editData?.itemDescription);
    }
  }, [editData, open]);



  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Update Item</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={12}>
                <Typography className="field-title">Item Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="item name"
                  {...getFieldProps("itemName")}
                  error={Boolean(touched.itemName && errors.itemName)}
                  helperText={touched.itemName && errors.itemName}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography className="field-title"> Type</Typography>
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={values?.incomeType}
                    onChange={(e) => setFieldValue("incomeType", e?.target?.value)}
                  >
                    <MenuItem value="Meal Service">Meal Service</MenuItem>
                    <MenuItem value="Rental">Rental</MenuItem>
                    <MenuItem value="Electricity">Electricity</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">Description</Typography>
                <TextField
                  fullWidth
                  rows={3}
                  multiline
                  size="small"
                  className="text-field"
                  placeholder="description"
                  {...getFieldProps("itemDescription")}
                  error={Boolean(touched.itemDescription && errors.itemDescription)}
                  helperText={touched.itemDescription && errors.itemDescription}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
